import React from 'react';
import { withTranslation } from '../common/translation';
import { FooterContainer, CopyrightText } from '../../style/theme';
import { OmdaLogoWhite } from '../common/icon';

const Footer = props => {
    const { t } = props;
    const thisYear = new Date().getFullYear();
    
    return (
        <FooterContainer className="footer">
            <OmdaLogoWhite />
            <CopyrightText>©{thisYear} {t('WEB_COPYRIGHT_NOTICE')}</CopyrightText>
        </FooterContainer>
    );
}

export default withTranslation()(Footer);
